import { TableColumn } from "@swimlane/ngx-datatable";
import { CtChipsControlOptions, CtControlConfiguration, CtControlTypes, CtModelConfiguration, CtModelDatatableOperators, CtModelRouteData, CtThemeTypes } from "@ctsolution/ct-framework";
import { CtWebapiGenericResponse, DataRequest, MethodEnum } from "@ctsolution/ct-webapi";

export const LEAD_CUSTOMER_SELECTION_COLUMNS: (TableColumn | any)[] = [
    {
        prop: "ReferenceName",
        name: "Nome di riferimento",
        width: 300,
        control: CtControlConfiguration
            .create()
            .setName('ReferenceName')
            .setLabel("Nome di riferimento")
            .setTheme(CtThemeTypes.MATERIAL),
        ColumnBuilder: {
            FilterEnabled: true
        }
    },
    {
        prop: "Phone",
        name: "Telefono",
        width: 200,
        control: CtControlConfiguration
            .create()
            .setName('Phone')
            .setLabel("Telefono")
            .setTheme(CtThemeTypes.MATERIAL)
            .setType(CtControlTypes.TEXT),
        ColumnBuilder: {
            FilterEnabled: true
        }
    },
    {
        prop: "Email",
        name: "E-mail",
        width: 200,
        control: CtControlConfiguration
            .create()
            .setName('Email')
            .setLabel("E-mail")
            .setTheme(CtThemeTypes.MATERIAL)
            .setType(CtControlTypes.TEXT),
        ColumnBuilder: {
            FilterEnabled: true
        }
    },
    {
        prop: "LeadType.Name",
        name: "Tipologia",
        width: 200,
        control: CtControlConfiguration
            .create()
            .setName('LeadType')
            .setLabel("Tipologia")
            .setTheme(CtThemeTypes.MATERIAL)
            .setType(CtControlTypes.ENUMERABLE)
            .setRemoteValueOptionsEndpoint(
                DataRequest
                    .create()
                    .setUrl(`/LeadType/Lookup`)
                    .setMethod(MethodEnum.POST)
                    .setBody(CtModelDatatableOperators.create())),
        ColumnBuilder: {
            FilterEnabled: true
        }
    },
    {
        prop: "LeadSource.Name",
        name: "Fonte",
        width: 200,
        control: CtControlConfiguration
            .create()
            .setName('LeadSource')
            .setLabel("Fonte")
            .setTheme(CtThemeTypes.MATERIAL)
            .setType(CtControlTypes.ENUMERABLE)
            .setRemoteValueOptionsEndpoint(
                DataRequest
                    .create()
                    .setUrl(`/LeadSource/Lookup`)
                    .setMethod(MethodEnum.POST)
                    .setBody(CtModelDatatableOperators.create())),
        ColumnBuilder: {
            FilterEnabled: true
        }
    },
    {
        prop: "LeadStatus.Name",
        name: "Stato",
        width: 200,
        control: CtControlConfiguration
            .create()
            .setName('LeadStatus')
            .setLabel("Stato")
            .setTheme(CtThemeTypes.MATERIAL)
            .setType(CtControlTypes.ENUMERABLE)
            .setRemoteValueOptionsEndpoint(
                DataRequest
                    .create()
                    .setUrl(`/LeadStatus/Lookup`)
                    .setMethod(MethodEnum.POST)
                    .setBody(CtModelDatatableOperators.create())),
        ColumnBuilder: {
            FilterEnabled: true
        }
    },
    {
        prop: "TagsJoined",
        name: "TAG",
        width: 200,
        control: CtControlConfiguration
            .create()
            .setName('Tags')
            .setLabel("TAG")
            .setTheme(CtThemeTypes.MATERIAL)
            .setType(CtControlTypes.CHIPS)
            .setRemoteValueOptionsEndpoint(
                DataRequest
                    .create()
                    .setUrl(`/Tag/Lookup`)
                    .setMethod(MethodEnum.POST)
                    .setBody(CtModelDatatableOperators.create())),


        ColumnBuilder: {
            FilterEnabled: true,
            OrderEnabled: false
        }
    },
];
